import Stoerer from './Stoerer';
import graphql from 'babel-plugin-relay/macro';
import { useLazyLoadQuery } from 'react-relay';
import { useParams } from 'react-router-dom';

export const StoererPreviewQuery = graphql`
    query StoererPreviewQuery($stoererId: Int!) {
        stoerer(id: $stoererId) {
            type
            text_headline
            text_intro
            text_content
            text_style
            image_url
            image_link
            button_type
            close_type
        }
    }
`;

const StoererPreview = () => {
    const { id } = useParams();
    const props = useLazyLoadQuery(StoererPreviewQuery, { stoererId: parseInt(id) });
    if (!props.stoerer) {
        return null;
    }

    return <Stoerer stoerer={props.stoerer} close={() => {}} />;
};

export default StoererPreview;
